import { useMutation } from '@apollo/client';
import { useTranslation } from 'react-i18next';
import { useNotifications, type ApiOptions } from '../helpers';
import { CreateTvBrandDocument } from './create.generated';

export const useCreateTVBrand = (options: ApiOptions<typeof CreateTvBrandDocument> = {}) => {
  const { t } = useTranslation();

  return useMutation(CreateTvBrandDocument, {
    ...useNotifications(CreateTvBrandDocument, {
      failure: (error) => error.message || t('api.common.error_generic'),
      success: t('api.tv_brands.create_success'),
    }),
    ...options,
  });
};
